/**
 * card.tsx - Superficie padrao do app (Card + CardHeader + CardBody).
 *
 * bg-surface, borda bg-border, --radius-card (8px). Sem padding proprio
 * quando composto com CardHeader/CardBody; use a prop padding no uso
 * avulso. elevated adiciona sombra sutil derivada de --ink (sem hex novo).
 */

import type { HTMLAttributes } from "react";

export function Card({
  padding,
  elevated = false,
  style,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { padding?: string; elevated?: boolean }) {
  return (
    <div
      style={{
        background: "var(--color-bg-surface)",
        border: "1px solid var(--color-bg-border)",
        borderRadius: "var(--radius-card)",
        padding: padding ?? 0,
        boxShadow: elevated
          ? "0 1px 3px color-mix(in srgb, var(--ink) 12%, transparent)"
          : undefined,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ style, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.75rem",
        padding: "0.875rem 1rem",
        borderBottom: "1px solid var(--color-bg-border)",
        fontFamily: '"Space Grotesk", sans-serif',
        fontSize: "1.0625rem",
        fontWeight: 600,
        color: "var(--color-text-primary)",
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardBody({ style, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div style={{ padding: "1rem", ...style }} {...props}>
      {children}
    </div>
  );
}
